import $ from 'jquery';

$('.dsp-toggle').on('click', function(e) {

  e.stopPropagation();

  const toggle = $(this);

  const toggleID = toggle.data('toggle-target');
  const toggleGroup = toggle.data('toggle-group');



  $(`[data-toggle-group=${toggleGroup}]`).removeClass('is-active');

  // all toggles that control this toggleID
  const toggles = $(`[data-toggle-target=${toggleID}]`);

  toggles.each(function() {
    $(this).addClass('is-active');
  });

  const target = $(`#${toggleID}`);
  target.addClass('is-active');

});